"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BadCFAHookMock__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        name: "BAD_HOOK",
        type: "error",
    },
    {
        inputs: [],
        name: "NOT_CFA",
        type: "error",
    },
    {
        inputs: [],
        name: "NOT_OWNER",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "sender",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "receiver",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "flowOperator",
                        type: "address",
                    },
                    {
                        internalType: "int96",
                        name: "flowRate",
                        type: "int96",
                    },
                ],
                internalType: "struct IConstantFlowAgreementHook.CFAHookParams",
                name: "",
                type: "tuple",
            },
        ],
        name: "onCreate",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "sender",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "receiver",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "flowOperator",
                        type: "address",
                    },
                    {
                        internalType: "int96",
                        name: "flowRate",
                        type: "int96",
                    },
                ],
                internalType: "struct IConstantFlowAgreementHook.CFAHookParams",
                name: "",
                type: "tuple",
            },
            {
                internalType: "int96",
                name: "",
                type: "int96",
            },
        ],
        name: "onDelete",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "sender",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "receiver",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "flowOperator",
                        type: "address",
                    },
                    {
                        internalType: "int96",
                        name: "flowRate",
                        type: "int96",
                    },
                ],
                internalType: "struct IConstantFlowAgreementHook.CFAHookParams",
                name: "",
                type: "tuple",
            },
            {
                internalType: "int96",
                name: "",
                type: "int96",
            },
        ],
        name: "onUpdate",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ConstantFlowAgreementV1",
                name: "_cfaV1",
                type: "address",
            },
        ],
        name: "setCFA",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "0x60a060405234801561001057600080fd5b50336080526080516102e461002f600039600060eb01526102e46000f3fe608060405234801561001057600080fd5b506004361061004c5760003560e01c80632742e95a146100515780636ac5bc3114610051578063ad53099b14610078578063e3d8fefe1461008d575b600080fd5b61006461005f36600461020e565b61009b565b604051901515815260200160405180910390f35b61008b610086366004610254565b6100e0565b005b61006461005f366004610278565b600080546001600160a01b031633146100c757604051631f9bdf8b60e21b815260040160405180910390fd5b60405163746e8e9f60e11b815260040160405180910390fd5b336001600160a01b037f00000000000000000000000000000000000000000000000000000000000000001614610129576040516338ebc58960e11b815260040160405180910390fd5b600080546001600160a01b0319166001600160a01b0392909216919091179055565b6001600160a01b038116811461016057600080fd5b50565b8035600b81900b811461017557600080fd5b919050565b60006080828403121561018c57600080fd5b6040516080810181811067ffffffffffffffff821117156101bd57634e487b7160e01b600052604160045260246000fd5b60405290508082356101ce8161014b565b815260208301356101de8161014b565b602082015260408301356101f18161014b565b604082015261020260608401610163565b60608201525092915050565b600080600060c0848603121561022357600080fd5b833561022e8161014b565b925061023d856020860161017a565b915061024b60a08501610163565b90509250925092565b60006020828403121561026657600080fd5b81356102718161014b565b9392505050565b60008060a0838503121561028b57600080fd5b82356102968161014b565b91506102a5846020850161017a565b9050925092905056fea2646970667358221220c100d0292f768d4d0159b9ba786280fd386f4a8f4754f2a5416539bac97eb26464736f6c63430008100033";
const isSuperArgs = (xs) => xs.length > 1;
class BadCFAHookMock__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.BadCFAHookMock__factory = BadCFAHookMock__factory;
BadCFAHookMock__factory.bytecode = _bytecode;
BadCFAHookMock__factory.abi = _abi;
//# sourceMappingURL=BadCFAHookMock__factory.js.map